<div class="animated" [ngClass]="{ 'container-fluid': editMode, 'container-filter': !editMode }">
    <form class="needs-validation" [formGroup]="form" novalidate>

        <h4>{{ title }} Recinto</h4>
        <ng-container *ngIf="!recinto && editMode">
            <div class="nota-info warning mb-2">
                <label class="col-form-label" for=""><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> No olvide crear los Cultivos vinculados</label>
            </div>
        </ng-container>

        <div class="row">
            <div class="col-md-12">

                <div class="row">

                    <div class="col-md-12">
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Datos Básicos
                                    <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedCabecera" [ngbCollapse]="isCollapsedCabecera">

                                    <div class="row">

                                        <div class="form-group col-xl-2 col-md-3">
                                            <label class="col-form-label required-field" for="Titular">Titular</label>
                                            <input formControlName="Titular" name="Titular" class="form-control" inputStyleClass="form-control" [ngClass]="displayFieldCss('Titular')" type="text" value="" aria-describedby="validationTitularFeedback">

                                            <div id="validationTitularFeedback" class="invalid-feedback" *ngIf="isFieldInvalid('Titular','required') || isFieldInvalid('Titular','cannotContainSpace')">
                                                Titular es obligatorio
                                            </div>
                                        </div>

                                        <div class="form-group col-xl-2 col-md-3">
                                            <label class="col-form-label required-field" for="Nif">NIF</label>
                                            <input formControlName="Nif" name="Nif" class="form-control" inputStyleClass="form-control" [ngClass]="displayFieldCss('Nif')" type="text" value="" aria-describedby="validationNIFFeedback">

                                            <div id="validationNIFFeedback" class="invalid-feedback" *ngIf="isFieldInvalid('Nif','required') || isFieldInvalid('Nif','cannotContainSpace')">
                                                NIF es obligatorio
                                            </div>
                                        </div>
                                        
                                        <div class="form-group col-xl-2 col-md-3">
                                            <label class="col-form-label required-field" for="inputTipoRecinto">Tipo de Recinto</label>
                                            <ng-select appendTo="body"
                                                [items]="tiposRecinto"
                                                bindLabel="Descripcion"
                                                bindValue="Id"
                                                formControlName="IdTipoRecinto"
                                                loadingText="Cargando..."
                                                [loading]="(!tiposRecinto || tiposRecinto.length === 0)"
                                                placeholder="-- Seleccione un Tipo --"
                                                [ngClass]="displayFieldCssNgSelect('IdTipoRecinto')"
                                                notFoundText="Tipo no encontrado"
                                                clearAllText="Eliminar selección">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                                </ng-template>
                                            </ng-select>

                                            <div id="validationTipoRecintoFeedback" class="invalid-feedback" *ngIf="isFieldInvalid('IdTipoRecinto','required') || isFieldInvalid('IdTipoRecinto','cannotContainSpace')">
                                                Tipo de Recinto es obligatorio
                                            </div>
                                        </div>

                                        <div class="form-group col-xl-2 col-md-3">
                                            <label class="col-form-label required-field" for="SuperficieTotal">Superficie Total (ha)</label>
                                            <input formControlName="SuperficieTotal" name="SuperficieTotal" class="form-control" readonly inputStyleClass="form-control" [ngClass]="displayFieldCss('SuperficieTotal')" type="text" value="" aria-describedby="validationSuperficieTotalFeedback">

                                            <div id="validationSuperficieTotalFeedback" class="invalid-feedback">
                                                <ng-container *ngIf="isFieldInvalid('SuperficieTotal','required') || isFieldInvalid('SuperficieTotal','cannotBeNullOrZero')">
                                                Superficie Total es obligatorio
                                                </ng-container>
                                                <!-- @scalero1: Dejo éste código por si vemos necesario impedir al usuario guardar el recinto bajo ésta condición
                                                <ng-container *ngIf="isFieldInvalid('SuperficieTotal','SuperficieTotalChanged', true)">
                                                    {{ superficieTotalHasChangedError }}
                                                </ng-container>
                                                -->
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">

                    <div class="col-md-12">
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedLocalizacion = !isCollapsedLocalizacion" [attr.aria-expanded]="!isCollapsedLocalizacion" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Localización
                                    <i *ngIf="isCollapsedLocalizacion" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedLocalizacion" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedLocalizacion" [ngbCollapse]="isCollapsedLocalizacion">
                                    <div *ngIf="dialogMode" class="row">
                                        <div class="form-group col-xl-2 col-md-3">
                                            <button type="button" class="btn btn-outline-success" [disabled]="!form.value.IdProvincia && !form.value.IdMunicipioSigPac" (click)="onShowSigpac()" title="Visualizar en SigPac">
                                                <i class="fa fa-external-link"></i> Visualizar en SigPac </button>
                                        </div>
                                    </div>

                                    <div class="row">

                                        <div class="form-group col-xl-2 col-md-3">
                                            <label class="col-form-label required-field" for="IdProvincia">Provincia</label>
                                            <ng-select appendTo="body"
                                                loadingText="Cargando..."
                                                [items]="provincias"
                                                [readonly]="!provincias"
                                                placeholder="-- Seleccione una Provincia --"
                                                [loading]="(!provincias || (provincias.length === 0))" 
                                                bindLabel="Descripcion"
                                                bindValue="Id"
                                                formControlName="IdProvincia"
                                                [ngClass]="displayFieldCssNgSelect('IdProvincia')"
                                                (change)="onSelectProvincia($event)"
                                                notFoundText="Provincia no encontrada"
                                                clearAllText="Eliminar selección">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                                </ng-template>
                                            </ng-select>
                                        </div>
        
                                        <div class="form-group col-xl-2 col-md-3">
                                            <label class="col-form-label required-field" for="IdMunicipio">Municipio</label>
                                            <ng-select appendTo="body"
                                                loadingText="Cargando..."
                                                [items]="municipios"
                                                [readonly]="!municipios"
                                                placeholder="-- Seleccione un Municipio --"
                                                [loading]="(!municipios && (form.value.IdProvincia !== null))" 
                                                bindLabel="Descripcion"
                                                bindValue="Id"
                                                formControlName="IdMunicipio"
                                                [ngClass]="displayFieldCssNgSelect('IdMunicipio')"
                                                (change)="onSelectMunicipio($event)"
                                                notFoundText="Municipio no encontrado"
                                                clearAllText="Eliminar selección">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                                </ng-template>
                                            </ng-select>
                                        </div>

                                        <div class="form-group col-xl-2 col-md-3">
                                            <label class="col-form-label required-field" for="IdMunicipioSigPac">Municipio SigPac</label>
                                            <input formControlName="IdMunicipioSigPac" name="IdMunicipioSigPac" readonly
                                                class="form-control" id="IdMunicipioSigPac" type="number">
                                        </div>
                                        
                                        <div class="form-group col-xl-1 col-md-3">
                                            <label class="col-form-label required-field" for="Agregado">Agregado</label>
                                            <input formControlName="Agregado" name="Agregado" maxlength="5"
                                                class="form-control" id="Agregado" type="number" value="" min="0">
                                        </div>
        
                                        <div class="form-group col-xl-1 col-md-3">
                                            <label class="col-form-label required-field" for="Zona">Zona</label>
                                            <input formControlName="Zona" name="Zona" maxlength="5"
                                                class="form-control" id="Zona" type="number" value="" min="0">
                                        </div>
        
                                        <div class="form-group col-xl-1 col-md-3">
                                            <label class="col-form-label required-field" for="Poligono">Polígono</label>
                                            <input formControlName="Poligono" name="Poligono" maxlength="5"
                                                class="form-control" id="Poligono" type="number" value="" min="0">
                                        </div>
        
                                        <div class="form-group col-xl-1 col-md-3">
                                            <label class="col-form-label required-field" for="Parcela">Parcela</label>
                                            <input formControlName="Parcela" name="Parcela" maxlength="10"
                                                class="form-control" id="Parcela" type="number" value="" min="0">
                                        </div>
        
                                        <div class="form-group col-xl-1 col-md-3">
                                            <label class="col-form-label required-field" for="Recinto">Recinto</label>
                                            <input formControlName="Recinto" name="Recinto" maxlength="10"
                                                class="form-control" id="Recinto" type="number" value="" min="0">
                                        </div>

                                        <input formControlName="UsoSigPac" name="UsoSigPac" 
                                        class="form-control" id="UsoSigPac" type="hidden">        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
